export default {
  // isSchedule: false
}